"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Captions = void 0;
var utilities_1 = require("../utilities");
var Captions = (function () {
    function Captions(apiCaptions) {
        this.backgroundColor = (apiCaptions === null || apiCaptions === void 0 ? void 0 : apiCaptions.backgroundColor) || '#000000';
        this.backgroundOpacity = (0, utilities_1.convertToNumber)(apiCaptions === null || apiCaptions === void 0 ? void 0 : apiCaptions.backgroundOpacity, 100);
        this.color = (apiCaptions === null || apiCaptions === void 0 ? void 0 : apiCaptions.color) || '#ffffff';
        this.edgeStyle = (apiCaptions === null || apiCaptions === void 0 ? void 0 : apiCaptions.edgeStyle) || 'none';
        this.fontFamily = (apiCaptions === null || apiCaptions === void 0 ? void 0 : apiCaptions.fontFamily) || 'Arial, sans-serif';
        this.fontOpacity = (0, utilities_1.convertToNumber)(apiCaptions === null || apiCaptions === void 0 ? void 0 : apiCaptions.fontOpacity, 100);
        this.fontSize = (0, utilities_1.convertToNumber)(apiCaptions === null || apiCaptions === void 0 ? void 0 : apiCaptions.fontSize, 100);
        this.windowColor = apiCaptions === null || apiCaptions === void 0 ? void 0 : apiCaptions.windowColor;
        this.windowOpacity = (0, utilities_1.convertToNumber)(apiCaptions === null || apiCaptions === void 0 ? void 0 : apiCaptions.windowOpacity, 100);
    }
    return Captions;
}());
exports.Captions = Captions;
